<template>
  <div class="mt-5" v-if="user">
    <h2>Brukeropplysninger</h2>
    <div class="section">
      <table class="table">
        <tbody>
          <tr>
            <th>Brukernavn</th>
            <td>{{ user.email }}</td>
          </tr>
          <tr>
            <th>Passord</th>
            <td>*******</td>
          </tr>
        </tbody>
      </table>
      <div v-if="changePassword">
        <h5>Byt passord</h5>
        <div class="row">
          <div class="col-md-6">
            <b-form @submit.prevent="onSubmit">
              <b-form-group id="input-group-1" label="Oppgi nåværende passord" label-for="input-1">
                <b-form-input
                  id="input-1"
                  v-model="form.password"
                  type="password"
                  required
                ></b-form-input>
              </b-form-group>

              <b-form-group id="input-group-2" label="Oppgi nytt passord" label-for="input-2">
                <b-form-input
                  id="input-2"
                  v-model="form.new_password"
                  type="password"
                  required
                ></b-form-input>
              </b-form-group>

              <b-form-group
                id="input-group-2"
                label="Oppgi nytt passord igjenn"
                label-for="input-2"
              >
                <b-form-input
                  id="input-2"
                  v-model="form.new_password_confirmation"
                  type="password"
                  required
                ></b-form-input>
              </b-form-group>
              <div
                class="invalid-feedback mt-2 mb-4"
                :style="{ display: error.length ? 'block' : 'none' }"
              >
                {{ error[0] }}
              </div>
              <b-button type="submit" variant="primary">Lagre nytt passord</b-button>
            </b-form>
          </div>
        </div>
      </div>
      <div v-else>
        <a href="#" @click.prevent="changePassword = !changePassword" class="btn btn-sm btn-primary"
          >Byt passord</a
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import axios from 'axios';

export default {
  computed: {
    ...mapGetters({
      user: 'auth/getUser',
    }),
  },
  data() {
    return {
      changePassword: false,
      rootUrl: process.env.VUE_APP_API_URL,
      form: {
        password: '',
        new_password: '',
        new_password_confirmation: '',
      },
      error: [],
    };
  },
  methods: {
    onSubmit() {
      const url = `${this.rootUrl}/changePassword`;
      axios
        .post(url, this.form)
        .then(response => {
          this.$bvToast.toast(`Passorded ble byttet`, {
            variant: 'success',
            title: 'Passord byttet',
            autoHideDelay: 5000,
          });
        })
        .catch(error => {
          this.error = Object.values(error.response.data)[0];
        });
    },
  },
};
</script>

<style scoped>
th {
  width: 50%;
}
</style>
